import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=2783b4b8&scoped=true&"
import script from "./GameList.vue?vue&type=script&lang=js&"
export * from "./GameList.vue?vue&type=script&lang=js&"
import style0 from "./GameList.vue?vue&type=style&index=0&id=2783b4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783b4b8",
  null
  
)

export default component.exports